export class ProductContextError extends Error {
  constructor(message) {
    super(message);
    this.name = 'ProductContextError';
  }
}

function idExplicito(valor, origem) {
  if (!Number.isInteger(valor) || valor <= 0) {
    throw new ProductContextError(
      `${origem} não retornou um produtos.id válido.`
    );
  }
  return valor;
}

function contextoBase({ id, codigo, nome, is_provisional }) {
  return {
    id,
    codigo: codigo || '',
    nome: nome || null,
    is_provisional: Boolean(is_provisional),
  };
}

function idUnicoDasPecas(pecas) {
  const ids = pecas.map((peca) =>
    idExplicito(peca?.produto_id, 'A lista de peças')
  );
  const idsUnicos = new Set(ids);
  if (idsUnicos.size !== 1) {
    throw new ProductContextError(
      'As peças retornadas pertencem a Products diferentes.'
    );
  }
  return ids[0];
}

export function produtoSelecionadoDeProduto(produto) {
  return contextoBase({
    id: idExplicito(produto?.id, 'O Product'),
    codigo: produto?.codigo,
    nome: produto?.nome,
    is_provisional: produto?.is_provisional,
  });
}

export function produtoSelecionadoDePecas({
  codigo,
  pecas,
  produtoExplicito = null,
}) {
  if (!Array.isArray(pecas)) {
    throw new ProductContextError('A resposta de peças é inválida.');
  }

  const contextoExplicito = produtoExplicito
    ? produtoSelecionadoDeProduto(produtoExplicito)
    : null;

  if (pecas.length === 0) {
    return contextoExplicito || contextoBase({
      id: null,
      codigo,
      nome: null,
      is_provisional: false,
    });
  }

  const produtoId = idUnicoDasPecas(pecas);
  if (contextoExplicito && contextoExplicito.id !== produtoId) {
    throw new ProductContextError(
      'As peças retornadas não pertencem ao Product selecionado.'
    );
  }

  return contextoExplicito || contextoBase({
    id: produtoId,
    codigo,
    nome: null,
    is_provisional: false,
  });
}

export function produtoSelecionadoDaFormalizacao(produto, contextoAnterior) {
  const formalizado = produtoSelecionadoDeProduto(produto);
  if (
    contextoAnterior?.id != null &&
    formalizado.id !== contextoAnterior.id
  ) {
    throw new ProductContextError(
      'A formalização retornou uma identidade de Product diferente.'
    );
  }
  return formalizado;
}

export function produtoSelecionadoDaImportacao(
  resultado,
  { codigo, nome, isProvisional }
) {
  return contextoBase({
    id: idExplicito(resultado?.produto_id, 'A importação'),
    codigo: resultado?.codigo_produto || codigo,
    nome,
    is_provisional: isProvisional,
  });
}

export function limparProdutoSelecionado() {
  return null;
}

export function codigoProdutoDaQuery(searchParams) {
  return searchParams.get('produto') || '';
}
